export const API_ERROR_NAME = 'ApiError'

export default class ApiError extends Error {
  constructor (originalError) {
    super(originalError.message)

    this.name = API_ERROR_NAME

    const nonStandardProperties = ['columnNumber', 'fileName', 'lineNumber', 'stack']

    for (let propertyName in nonStandardProperties) {
      this[propertyName] = originalError.hasOwnProperty(propertyName) ? originalError[propertyName] : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/order-api/error/api-error.js